import Axios from "axios";
import { SETTINGS } from "../../../../../properties/ApiProps";

export const TrainingHourRangeRepository = {
  fetch: (id) => {
    return Axios.get(`${SETTINGS.API_URL}trainingHourRanges/${id}`);
  },
  fetchAll: (gradingSchemaId) => {
    return Axios({
      url: SETTINGS.API_URL + "trainingHourRanges",
      method: "GET",
      params: {
        gradingSchemaId: gradingSchemaId,
      },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  create: (data) => {
    return Axios({
      url: SETTINGS.API_URL + "trainingHourRanges",
      method: "POST",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  update: (data) => {
    return Axios({
      url: SETTINGS.API_URL + "trainingHourRanges",
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  delete: (id) => {
    return Axios.delete(`${SETTINGS.API_URL}trainingHourRanges/${id}`);
  },
};
